import styled, { css } from 'styled-components';

const anchorLinkNavigationTheme = css`
  @media (min-width: 1199px) {
    overflow: hidden;
    height: 635px;
    pointer-events: none;

    & > div {
      pointer-events: auto;
    }

    .website-header {
      .icon-down-caret {
        fill: var(--white);
      }
      .menu-item--parent-link,
      .menu-item--parent-link a,
      .menu-item--parent-link i {
        color: var(--white);
      }
    }
  }
`;

export const HeaderContainer = styled.div`
  ${({ hasAnchorLinkNavigation }) => (hasAnchorLinkNavigation ? anchorLinkNavigationTheme : '')};
  position: ${({ bannerData, inline }) =>
    (bannerData.height > 0 && !bannerData.scrolled) || inline ? 'absolute' : 'fixed'};
  top: ${({ bannerData }) =>
    bannerData.height > 0 && bannerData.scrolled ? `${bannerData.height}px` : '0'};
  width: 100%;
  z-index: var(--z-website-header);
  transition: all 0.7s;

  .website-simple-header {
    display: none;
  }

  .website-header {
    display: block;
  }

  &.show-simple {
    .website-simple-header {
      display: flex;
    }

    .website-header {
      display: none;
    }
  }
`;

export const HorizontalProgressBar = styled.div`
  display: flex;

  & > div:first-child {
    z-index: 999;
    position: static !important;
    left: 0;
    width: 10%;
    height: 4px;
    bottom: -4px;
    background-color: var(--titan-blue-3);
    overflow: hidden;
  }

  & > div:nth-child(2) {
    top: unset !important;
    position: static !important;
  }
`;
